import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { Analytics } from '@vercel/analytics/react';
import { SignInModalProvider } from './contexts/SignInModalContext';
import { InfluencerProvider } from './contexts/InfluencerContext';
import AuthGuard from './components/AuthGuard';
import AppRouter from './AppRouter';
import './index.css';

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider 
        publishableKey={clerkPublishableKey}
        appearance={{
          baseTheme: dark,
          variables: {
            colorPrimary: '#3b82f6',
            colorBackground: '#0f172a',
            colorInputBackground: '#1e293b',
            colorInputText: '#f8fafc',
            colorText: '#f8fafc',
            colorTextSecondary: '#94a3b8',
            colorDanger: '#ef4444',
            colorSuccess: '#10b981',
            colorWarning: '#f59e0b',
          },
          elements: {
            rootBox: 'mx-auto',
            card: 'bg-slate-900 border border-slate-700 shadow-2xl',
            navbar: 'bg-slate-900 border-r border-slate-700',
            navbarButton: 'text-slate-300 hover:text-white hover:bg-slate-800',
            navbarButtonActive: 'text-blue-400 bg-slate-800',
            pageScrollBox: 'bg-slate-900',
            page: 'bg-slate-900',
            profileSection: 'border-slate-700',
            profileSectionTitle: 'text-white',
            profileSectionContent: 'text-slate-300',
            formFieldLabel: 'text-slate-300',
            formFieldInput: 'bg-slate-800 border-slate-600 text-white placeholder:text-slate-500',
            formButtonPrimary: 'bg-blue-600 hover:bg-blue-500 text-white',
            profileSectionPrimaryButton: 'bg-blue-600 hover:bg-blue-500 text-white',
            avatarBox: 'border-2 border-blue-500',
            badge: 'bg-blue-500/20 text-blue-400',
            headerTitle: 'text-white',
            headerSubtitle: 'text-slate-400',
            socialButtonsBlockButton: 'bg-slate-800 border-slate-600 text-white hover:bg-slate-700',
            dividerLine: 'bg-slate-700',
            dividerText: 'text-slate-500',
            footerActionLink: 'text-blue-400 hover:text-blue-300',
            formFieldAction: 'text-blue-400 hover:text-blue-300',
            identityPreviewEditButton: 'text-blue-400 hover:text-blue-300',
          },
        }}
      >
        <SignInModalProvider>
          <InfluencerProvider>
            <AuthGuard>
              <AppRouter />
            </AuthGuard>
          </InfluencerProvider>
        </SignInModalProvider>
      </ClerkProvider>
      <Analytics />
    </BrowserRouter>
  </React.StrictMode>,
);
